
import { Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { ChildEvent, ScrBaseComponent } from '../../../base.component';
import { AccountService, LinkedAccountCreateRequest } from '../../../../services';
import { pick } from 'lodash-es';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-linked-accounts-create',
  templateUrl: './linked-accounts-create.component.html'
})
export class LinkedAccountsCreateComponent extends ScrBaseComponent implements OnInit {

  @Output() emitAction = new EventEmitter<ChildEvent>();

  public model = new LinkedAccountCreateRequest();

  @ViewChild('form', { static: false }) form!: NgForm;

  constructor(private accountService: AccountService,
    private confirmService: ConfirmationService) {
    super();
  }

  @HostListener('document:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): boolean {
    if (event.defaultPrevented) {
      return false;
    }
    if ((event.code === 'KeyF') && (event.altKey)) {
      const num = `${new Date().getTime()}`.substring(6, 10);
      this.model.account.linkedAccountName = 'Linked Acct ' + num;
      this.model.user.firstName = 'First';
      this.model.user.lastName = 'Last';
      this.model.user.phone = `732-699-${num}`;
      this.model.user.email = `jguistwite+${num}@gmail.com`;
      this.model.user.confirmEmail = this.model.user.email;
      this.model.user.country = 'us';
      this.model.user.address1 = '100 Main Street';
      this.model.user.city = 'Anytown';
      this.model.user.state = 'NJ';
      this.model.user.zip = '08807';
    }
    return false;
  }


  ngOnInit(): void {
    this.observe(this.accountService.getAccount(true, false), rsp => {

      // pre-populate user's country and account billing country.
      this.model.user.country = 'us';
      this.model.account.billingCountry = 'us';
      // set to empty so that they are marked dirty and thus required if user presses form button.
      this.model.user.state = '';
      this.model.account.billingState = '';

      // set to blank to workaround mask expression changed error.
      this.model.user.zip = '';
      this.model.account.billingZip = '';

      this.model.account.company = rsp.account.company;
      this.model.account.companyUrl = rsp.account.companyUrl;
      this.model.account.fein = rsp.account.fein;

      Object.assign(this.model.account,
        pick(rsp.account,
          ['company', 'companyUrl', 'fein',
            'firstName', 'lastName', 'phone', 'phoneExtension', 'email', 'address1', 'address2', 'city', 'state', 'zip', 'country']));
      return false;
    });

  }

  cancelCreateNewLinkedAccount(): void {
    this.confirmService.confirm({
      key: 'confirmCancel',
      header: 'Confirm Cancellation',
      message: 'Are you sure you want to cancel the request?',
      accept: () => {
        this.model = new LinkedAccountCreateRequest();
        this.form.reset(this.model);
        this.emitAction.emit({ action: 'cancel', value: 'cancel' });
      },
      reject: () => {
        this.confirmService.close();
      }
    });
  }

  submit(form: NgForm) {

    for (const name in form.controls) {
      form.controls[name].markAsTouched();
    }

    if (!form.valid) {
      this.scrollToFirstError();
      return;
    }

    this.observe(this.accountService.createLinkedAccount(this.model), rsp => {
      const firstMessage = this.getFirstMessage(rsp);
      this.emitAction.emit({ action: 'submit', message: firstMessage });
      return false;
    });

  }

  copyBillingFromUser(): boolean {
    this.model.account.billingFirstName = this.model.user.firstName;
    this.model.account.billingLastName = this.model.user.lastName;
    this.model.account.billingPhone = this.model.user.phone;
    this.model.account.billingPhoneExtension = this.model.user.phoneExtension;
    this.model.account.billingEmail = this.model.user.email;
    this.model.account.billingCountry = this.model.user.country;
    this.model.account.billingAddress1 = this.model.user.address1;
    this.model.account.billingAddress2 = this.model.user.address2;
    this.model.account.billingCity = this.model.user.city;
    this.model.account.billingState = this.model.user.state;
    this.model.account.billingZip = this.model.user.zip;
    return false;
  }

  copyBillingFromContact(): boolean {
    this.model.account.billingFirstName = this.model.account.firstName;
    this.model.account.billingLastName = this.model.account.lastName;
    this.model.account.billingPhone = this.model.account.phone;
    this.model.account.billingPhoneExtension = this.model.account.phoneExtension;
    this.model.account.billingEmail = this.model.account.email;
    this.model.account.billingCountry = this.model.account.country;
    this.model.account.billingAddress1 = this.model.account.address1;
    this.model.account.billingAddress2 = this.model.account.address2;
    this.model.account.billingCity = this.model.account.city;
    this.model.account.billingState = this.model.account.state;
    this.model.account.billingZip = this.model.account.zip;
    return false;
  }
}
